export default class AuthenticationException extends Error {
  constructor(message = 'User not authenticated') {
    super(message);
    this.name = 'AuthenticationException';
    this.code = 'custom/user-not-authenticated';
  }
}
